module.exports = __webpack_public_path__ + "img/past-events_nba-all-star.572a1c3d.jpg";